import { extensionMenus } from "globals/configuration/extension";

const Attributes = {
  formSize: "md",
  columns: 2,
  enableAddButton: true,
  enableAdvanceSearch: true,
  modes: extensionMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      submenu: item.submenu
        ? item.submenu.map((subItem) => {
            return {
              id: subItem.key,
              name: subItem.name,
              iconName: subItem.icon,
              url: subItem.url,
              description: subItem.description,
            };
          })
        : [],
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  create: "company/create",
  update: "company/update",
  list: "company/list",
  delete: "company/delete",
};

export { Attributes, operationURLS };
